import { useErrorContext } from "@context-providers/error-boundary/error-handling-context";
import { Grid } from "@mui-wrapper";
import { INTEGRATION_INFO } from "@src/constants/integrations-constants";
import { Dialog, Text, useToast } from "@flat-ui";
import { ProjectEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useState } from "react";
/** Renders project integration connect dialog */
export function ProjectIntegrationsDisconnectDialog({
  integrationsService,
  integrationId,
  setProjectIntegrations,
  onClose
}) {
  const {
    handleErrorWithToast
  } = useErrorContext();
  const {
    openToast
  } = useToast();
  const {
    trackEvent
  } = useTrackEvent();
  const [isLoading, setIsLoading] = useState(false);
  async function onDisconnectConfirm() {
    trackEvent({
      name: ProjectEvents.disconnectIntegration,
      props: {
        integrationId
      }
    });
    try {
      setIsLoading(true);
      const updatedProjectIntegrations = await integrationsService.disconnectProject(integrationId);
      setProjectIntegrations(updatedProjectIntegrations);
      openToast({
        title: `${INTEGRATION_INFO[integrationId].displayName} has been disabled in this project`
      });
      onClose();
    } catch (error) {
      handleErrorWithToast({
        id: `disableIntegration-${Date.now().toString()}`,
        title: `Failed to disable ${INTEGRATION_INFO[integrationId].displayName}`,
        error
      });
    } finally {
      setIsLoading(false);
    }
  }
  return <Dialog open={true} onConfirm={() => void onDisconnectConfirm()} showSpinner={isLoading} confirmText="Disable" title={`Disable ${INTEGRATION_INFO[integrationId].displayName}?`} onCancel={onClose} variant="danger">
      <Grid container sx={{
      maxWidth: "100%",
      alignItems: "center",
      flexDirection: "column",
      justifyContent: "center"
    }}>
        <Text variant="bodyM" sx={{
        marginBottom: "32px"
      }}>
          {`Disabling ${INTEGRATION_INFO[integrationId].displayName} will prevent
          you from using any of its features in this project. You can enable it
          again at any time`}
        </Text>
      </Grid>
    </Dialog>;
}